import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Discussion, Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  discussions: Identifiable<Discussion>[];
  currentPage: number;
  canLoadMore: boolean;
  retrieveDiscussions(
    request: Boundaries["retrieveDiscussions"]["request"],
  ): void;
}

function useRetrieveDiscussions(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveDiscussionsRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveDiscussionsRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveDiscussionsRequestFailure(project),
    ),
    discussions: useSelector(() => selector.getDiscussions(project)),
    currentPage: useSelector(() => selector.getDiscussionsCurrentPage(project)),
    canLoadMore: useSelector(() => selector.canLoadMoreDiscussions(project)),
    retrieveDiscussions: core.retrieveDiscussions,
  };
}

export { useRetrieveDiscussions };
